app.service('notIssuedOrderView', function() {

	function init() {

	}
	return {
		init
	};
});
